export default __webpack_public_path__ + "47fc77e6e58cfdda4227b1fd557fd4d5.png";